import { ref } from "vue";

/**
 * Shared state for the sign-up/log-in modal rendered by AppTopBar, so any
 * page (e.g. the "Sign up" links in guest hints) can open it directly.
 */
const isOpen = ref(false);
const mode = ref<"login" | "register">("login");

export function useAuthModal() {
  function open(nextMode: "login" | "register") {
    mode.value = nextMode;
    isOpen.value = true;
  }

  function close() {
    isOpen.value = false;
  }

  return { isOpen, mode, open, close };
}
